import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'RuleSort'
})
export class RuleSortPipe implements PipeTransform {

    transform(value: Array<any>): Array<any> {
        if (value == null) {
            return null;
        }
        let result: Array<any>;
        value.sort((a: any, b: any) => {
            if (Number(a.order) < Number(b.order)) {
                return -1;
            } else if (Number(a.order) > Number(b.order)) {
                return 1;
            } else {
                return 0;
            }
        });
        return value;
    }

}



// WEBPACK FOOTER //
// ./src/app/components/price-rules/rules-sort.pipe.ts